var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillSummary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.342,
    height: 14,
    viewBox: "0 0 18.342 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #101010;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-check-for-payment",
    className: "cls-1",
    d: "M2.667,3A1.627,1.627,0,0,0,1,4.556V6.111A1.627,1.627,0,0,0,2.667,7.667H4.335V17H6A.836.836,0,0,1,7.67,17H9.337A.836.836,0,0,1,11,17h1.667a.836.836,0,0,1,1.667,0h1.667V7.667h1.667a1.626,1.626,0,0,0,1.667-1.556V4.556A1.626,1.626,0,0,0,17.675,3Zm0,1.556H4.335V6.111H2.667ZM6,4.556H14.34V14.667H6Zm10,0h1.667V6.111H16.007ZM7.67,6.111V7.667h5V6.111Zm0,3.111v1.556H11V9.222Z",
    transform: "translate(-1 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillSummary);
export default __webpack_public_path__ + "static/media/bill_summary.494d66ecf4ec7aa687cb6fae2ca61bb3.svg";
export { ForwardRef as ReactComponent };